import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PropertyTypeCompanyService } from './property-type-company.service';

const service = new PropertyTypeCompanyService();

export interface PropertyTypeCompanyState {}

const PropertyTypeCompanyStore: Module<PropertyTypeCompanyState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async searchPropertyTypeCompanies(_, query?: LocationQuery) {
         return service.getPropertyTypeCompanies(query);
      },
   },
};

export default PropertyTypeCompanyStore;
